import React from 'react';
import renderHTML from 'react-render-html';
import { LeftAlignedPromoWrapper, LeftAlignedPromoInner, ModalButton } from '../styles/leftAlignedPromo.style';
import { BlueButton, BlueButtonExternal, RTE } from '../../../utils/atoms';
import { FooterModal } from '../../footer-modal';

/**
 * Returns an internal or external link
 * @param {object} props Incoming props
 * @returns {XML} an internal or external link
 */
const ctaLinkRender = ({ ctaLink, ctaText }) => {
  if (ctaLink.indexOf('http') > -1) {
    return (
      <BlueButtonExternal href={ctaLink} label={ctaText} target="blank">
        <span>{ctaText}</span>
      </BlueButtonExternal>
    );
  }
  return (
    <BlueButton to={ctaLink} label={ctaText}>
      <span>{ctaText}</span>
    </BlueButton>
  );
};

/**
 * Left Aligned Promo Component
 * @param {object} props Incoming Props
 * @returns {XML} A Left Aligned Promo Component
 */
class LeftAlignedPromo extends React.Component {
  /**
   * constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      showModal: false,
    };
  }

  /**
   * Open modal
   * @param {object} e event object
   */
  openModal(e) {
    e.stopPropagation();
    this.setState({
      showModal: true,
    });
  }

  /**
   * Close Modal
   */
  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  /**
   * Render component
   * @returns {JSX} Component JSX
   */
  render() {
    const {
      title,
      subtitle,
      ctaLink,
      ctaText,
      backgroundImage,
      description,
      small,
      childContentfulLeftAlignedPromoDescriptionTextNode,
      rightAlignedImage,
      modalContent,
      swapAlignment,
    } = this.props;
    const { showModal } = this.state;
    return (
      <LeftAlignedPromoWrapper
        className={`${small ? 'xfl-left-aligned-promo--small' : ''}
        ${swapAlignment ? 'xfl-left-aligned-promo--swap' : ''}`}
        backgroundImage={backgroundImage && backgroundImage.file ? backgroundImage.file.url : ''}
      >
        <LeftAlignedPromoInner>
          {swapAlignment ? (
            <div className="xfl-left-aligned-promo__image">
              {rightAlignedImage && rightAlignedImage.file ? <img src={rightAlignedImage.file.url} alt="" /> : null}
            </div>
          ) : null}
          <div className="xfl-left-aligned-promo__content">
            <h4>{title}</h4>
            {subtitle ? <p className="subtitle">{subtitle}</p> : null}
            {rightAlignedImage && rightAlignedImage.file
              ? <img className="xfl-left-aligned-promo__mobile-image" src={rightAlignedImage.file.url} alt="" />
              : null}
            {description ? <p className="xfl-left-aligned-promo__description">{renderHTML(description)}</p> : null}
            {childContentfulLeftAlignedPromoDescriptionTextNode
              && childContentfulLeftAlignedPromoDescriptionTextNode.childMarkdownRemark
              && childContentfulLeftAlignedPromoDescriptionTextNode.childMarkdownRemark.html ? (
                <RTE
                  className="xfl-left-aligned-promo__description"
                >
                  {renderHTML(childContentfulLeftAlignedPromoDescriptionTextNode.childMarkdownRemark.html)}
                </RTE>
              ) : null}
            {ctaLink && ctaText ? ctaLinkRender({ ctaLink, ctaText }) : null}
            {modalContent && (
              <ModalButton onClick={e => this.openModal(e)}><span>Read More</span></ModalButton>
            )}
          </div>
          {!swapAlignment ? (
            <div className="xfl-left-aligned-promo__image">
              {rightAlignedImage && rightAlignedImage.file ? <img src={rightAlignedImage.file.url} alt="" /> : null}
            </div>
          ) : null}
        </LeftAlignedPromoInner>
        {showModal && (
          <FooterModal
            title={title}
            content={modalContent}
            close={() => this.closeModal()}
          />
        ) }
      </LeftAlignedPromoWrapper>
    );
  }
}

export default LeftAlignedPromo;



// WEBPACK FOOTER //
// ./src/components/left-aligned-promo/components/leftAlignedPromo.js